<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Laporan Purchase Order</h2>

      <br />

      <form class="filter" @submit.prevent="loadData">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label for="">Pembayaran</label>
          <select v-model="filter.pembayaran">
            <option value="ALL">Semua</option>
            <option value="LUNAS">Lunas</option>
            <option value="BELUM_LUNAS">Belum Lunas</option>
          </select>
        </div>
        <div class="form-group">
          <label for="">Supplier</label>
          <input type="text" v-model="filter.supplier">
        </div>
        <div class="form-group">
          <label>&nbsp;</label>
          <button type="button" class="btn-fill" @click="loadData">Filter</button>
        </div>
        <div class="form-group">
          <label>Export Data</label>
          <button type="button" class="btn-outline">Export CSV</button>
        </div>
      </form>

      <div class="summary">
        <div>
          <div class="card">
            <div class="card-body">
              <h2>{{ summary.totalNota }}</h2>
              <p>Jumlah Nota</p>
            </div>
          </div>
        </div>
        <div>
          <div class="card">
            <div class="card-body">
              <h2>Rp {{ summary.totalHutang | number }}</h2>
              <p>Total Hutang</p>
            </div>
          </div>
        </div>
        <div>
          <div class="card">
            <div class="card-body">
              <h2>Rp {{ summary.totalLunas | number }}</h2>
              <p>Total Lunas</p>
            </div>
          </div>
        </div>
        <div>
          <div class="card">
            <div class="card-body">
              <h2>Rp {{ summary.totalPurchaseOrder | number }}</h2>
              <p>Total Purchase Order</p>
            </div>
          </div>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>No</th>
            <th>Divisi</th>
            <th>Nomor PO</th>
            <th>Tgl PO</th>
            <th>Supplier</th>
            <th>Grand Total</th>
            <th>Keterangan</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ ++index }}</td>
            <td>{{ item.divisi }}</td>
            <td>{{ item.no_order }}</td>
            <td>{{ moment(item.tgl_order).format("DD/MM/YYYY") }}</td>
            <td>{{ item.supplier }}</td>
            <td>Rp {{ item.grand_total | number }}</td>
            <td>{{ item.keterangan || "-" }}</td>
            <td>
              {{
                parseInt(item.total_bayar) >= parseInt(item.grand_total) ? "Lunas" : "Belum Lunas"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "../../api/Api";
import moment from "moment";

export default {
  name: "Home",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      data: [],
      summary: {},
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-D"),
        pembayaran: "ALL"
      },
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      this.filter.id_toko = this.$toko.id;
      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      api
        .get("/v1/purchase?" + this.$objectToQuery(this.filter))
        .then((r) => {
          this.loading = false;
          this.data = r.data;

          this.summary = {
            totalNota: r.summary.total_nota,
            totalHutang: r.summary.total_hutang,
            totalLunas: r.summary.total_lunas,
            totalPurchaseOrder: r.summary.total_purchase_order,
          };
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$store.commit("settings/setMenuActive", "/laporan/purchase-order");
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 20px;
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }
  .summary {
    display: grid;
    margin-bottom: 20px;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;

    .card-body {
      p,
      h2 {
        margin: 0;
      }

      h2 {
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
      }
    }
  }

  .table {
    .void {
      color: #f00;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/PurchaseOrder.vue